﻿(function ($, document, ns, undefined) {
  ns.initSiteSearchAutocomplete = function () {

    var datasetsReceived = [];

    var allItemsCache = {
      'Producers': []
    };

    var filterKeyMapping = {
      'Producers': 'producer',
      'Grapes': 'grape',
      'Type': 'type',
      'Regions': 'region',
      'Products': 'product'
    };

    var dataSourceMapping = {
      'Grapes': {
        source: new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.obj.whitespace('ItemName'),
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          limit: 10,
          remote: {
            cache: false,
            url: '/api/products/auto-complete-grapes?term=%QUERY',
            wildcard: '%QUERY',
            rateLimitBy: 'debounce',
            rateLimitWait: 250,
            transform: function (response) {
              return response.map(function (grape) {
                return {
                  ItemName: grape.ItemName,
                  ItemID: grape.ItemID,
                  PageUrl: grape.ItemUrl.replace('~/', '/')
                };
              });
            }
          }
        }),
        header: '<span class="tt-heading">Grapes</span>',
      },
      'Type': {
        source: new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.obj.whitespace('ItemName'),
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          limit: 10,
          remote: {
            cache: false,
            url: '/api/products/auto-complete-type?term=%QUERY',
            wildcard: '%QUERY',
            rateLimitBy: 'debounce',
            rateLimitWait: 250,
            transform: function (response) {
              return response.map(function (type) {
                return {
                  ItemName: type.ItemName,
                  ItemID: type.ItemID,
                  PageUrl: type.ItemUrl.replace('~/', '/')
                };
              });
            }
          }
        }),
        header: '<span class="tt-heading">Type</span>',
      },
      'Regions': {
        source: new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.obj.whitespace('ItemName'),
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          limit: 10,
          remote: {
            cache: false,
            url: '/api/products/auto-complete-places?term=%QUERY',
            wildcard: '%QUERY',
            rateLimitBy: 'debounce',
            rateLimitWait: 250,
            transform: function (response) {
              return response.map(function (region) {
                return {
                  ItemName: region.ItemName,
                  ItemID: region.ItemID,
                  PageUrl: region.ItemUrl.replace('~/', '/')
                };
              });
            }
          }
        }),
        header: '<span class="tt-heading">Regions</span>',
      },
      'Products': {
        source: new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.obj.whitespace('ItemName'),
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          limit: 10,
          remote: {
            cache: false,
            url: '/api/products/auto-complete-products?term=%QUERY',
            wildcard: '%QUERY',
            rateLimitBy: 'debounce',
            rateLimitWait: 250,
            transform: function (response) {
              return response.map(function (product) {
                return {
                  ItemName: product.ItemName,
                  ItemID: product.ItemID,
                  PageUrl: product.ItemUrl.replace('~/', '/')
                };
              });
            }
          }
        }),
        header: '<span class="tt-heading">Products</span>',
      },
      'Producers': {
        source: new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.obj.whitespace('ItemName'),
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          limit: 10,
          remote: {
            cache: false,
            url: '/api/products/auto-complete-producers?term=%QUERY',
            wildcard: '%QUERY',
            rateLimitBy: 'debounce',
            rateLimitWait: 250,
            transform: function (response) {
              return response.map(function (producer) {
                return {
                  ItemName: producer.ItemName,
                  ItemID: producer.ItemID,
                  PageUrl: producer.ItemUrl.replace('~/', '/')
                };
              });
            }
          }
        }),
        header: '<span class="tt-heading">Producers</span>',
      },
      'ProductByID': {
        source: new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.obj.whitespace('ItemName'),
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          limit: 1,
          remote: {
            cache: false,
            url: '/api/products/auto-complete-product-id?productId=%QUERY',
            wildcard: '%QUERY',
            rateLimitBy: 'debounce',
            rateLimitWait: 250,
            transform: function (response) {
              return response.map(function (product) {
                return {
                  ItemName: `(${product.ItemID}) ${product.ItemName} `,
                  ItemID: product.ItemID,
                  PageUrl: product.ItemUrl.replace('~/', '/')
                };
              });
            }
          }
        }),
        header: '<span class="tt-heading">Product</span>'
      }
    };

    $('[data-site-search-flyout-autocomplete]').each(function () {
      var $this = $(this);
      var $spinner = $this.next('.tt-loading-indicator');

      function showSpinner() {
        $spinner.show();
      }

      function hideSpinner() {
        $spinner.hide();
      }

      var autocompleteTypes = $this.attr('data-autocomplete-types');
      if (!autocompleteTypes) {
        console.log("skipping element without the required types data-attribute.");
        return;
      }

      var autocompleteOrder;
      try {
        autocompleteOrder = JSON.parse(autocompleteTypes);
      } catch (e) {
        console.log("skipping element with invalid types data-attribute." + autocompleteTypes);
        return;
      }

      var datasets = autocompleteOrder.map(function (resultType) {
        if (dataSourceMapping[resultType.Heading]) {
          return {
            name: resultType.Heading.toLowerCase(),
            display: function (suggestion) {
              if (suggestion.SearchResult == 1) {
                return suggestion.ItemName;
              }
              return $this.val();
            },
            limit: resultType.MaxNoOfResults,
            source: dataSourceMapping[resultType.Heading].source,
            templates: {
              header: dataSourceMapping[resultType.Heading].header,
              footer: function (context) {
                var footerContent = '<hr class="tt-dataset-separator">';

                if (!resultType.SearchForAllLinkText || resultType.SearchForAllLinkText === "") {
                  return footerContent;
                }

                if (footerTemplateMapping[resultType.Heading]) {
                  footerContent += footerTemplateMapping[resultType.Heading](context, resultType);
                }

                return footerContent;
              },
              suggestion: function (context) {
                var suggestionTemplate = '<a href="{{PageUrl}}" class="tt-text-suggestion">{{ItemName}}</a>';
                return Mustache.render(suggestionTemplate, context);
              }
            }
          };
        }
      });

      var footerTemplateMapping = {
        'Producers': function (context, resultType) {
          const footerContent = createFooterLink(resultType, context.query);
          return footerContent;
        }
      };

      function getCustomQueryUrl(filterType, items) {
        const filterKey = filterKeyMapping[filterType] || filterType.toLowerCase();
        const itemIds = items.map(item => item.ItemID);


        let queryUrl = `/search?filter=${filterKey}:(${itemIds.join(',')})`;

        while (queryUrl.length > 2000 && itemIds.length > 1) {
          itemIds.pop();
          queryUrl = `/search?filter=${filterKey}:(${itemIds.join(',')})`;
        }

        return queryUrl;
      }

      function handleFooterClick(event) {
        event.preventDefault();
        const filterType = $(this).data('filter-type');
        const query = $(this).data('query');
        const linkSelector = this;
        const allItems = allItemsCache[filterType];

        if (allItems.length === 0) {
          fetchAllItems(filterType, query, function (items) {
            const queryUrl = getCustomQueryUrl(filterType, items);
            $(linkSelector).attr('href', queryUrl);
            window.location.href = queryUrl;
          });
        } else {
          const queryUrl = getCustomQueryUrl(filterType, allItems);
          window.location.href = queryUrl;
        }
      }

      function createFooterLink(resultType, query) {
        return `<a href="#"
        class="tt-search-for-all-btn"
        id="view-all-${resultType.Heading.toLowerCase()}-btn"
        data-filter-type="${resultType.Heading}"
        data-query="${query}">`
          + resultType.SearchForAllLinkText.replace('{% term %}', `'${query}'`)
          + '</a>';
      }

      function fetchAllItems(filterType, query, callback) {
        const url = `/api/products/auto-complete-${filterType.toLowerCase()}?term=${query}&limit=100`;
        $.ajax({
          url: url,
          success: function (response) {
            allItemsCache[filterType] = response.map(function (item) {
              return {
                ItemName: item.ItemName,
                ItemID: item.ItemID,
                PageUrl: item.ItemUrl.replace('~/', '/')
              };
            });
              callback(allItemsCache[filterType]);
          },
          error: function() {
            allItemsCache[filterType] = [];
          }
        });
      }

      $(document).off('click', '.tt-search-for-all-btn').on('click', '.tt-search-for-all-btn', handleFooterClick);

      datasets.push({
        name: 'productbyid',
        display: function (suggestion) {
          return suggestion.ItemName;
        },
        limit: 1,
        source: dataSourceMapping['ProductByID'].source,
        templates: {
          header: dataSourceMapping['ProductByID'].header,
          suggestion: function (context) {
            return Mustache.render('<a href="{{PageUrl}}" class="tt-text-suggestion">{{ItemName}}</a>', context);
          }
        }
      });

      $this.typeahead({
        highlight: true,
        minLength: 2,
        hint: true,
        autoselect: false
      }, ...datasets)
        .on('typeahead:select', function (ev, suggestion, datasetName) {
          if (datasetName !== 'productbyid') {
            addRecentSearch(suggestion);
          }
          
          window.location.replace(suggestion.PageUrl);
        })
        .on('typeahead:asyncrequest', function () {
          showSpinner();
        })
        .on('typeahead:asyncreceive', function (event, query, datasetName) {
          hideSpinner();

          const correctedDatasetName =
            datasets
              .map((d) => d.name)
              .find((name) =>
                query.includes(name))
                || datasetName;

          if (!datasetsReceived.some((d) => d.name === correctedDatasetName)) {
            datasetsReceived.push({
              name: correctedDatasetName,
              hasResults: event.target.getAttribute(`data-results-${correctedDatasetName}`) === "true",
            });
          }

          updateUIAfterFetch($(this), datasets.length);
          updateViewAllButton($(this));
        })
        .on('typeahead:asynccancel', function (event, query, datasetName) {
          hideSpinner();

          if (typeof datasetName === "string" && datasets.map(d => d.name).includes(datasetName)) {
            if (!datasetsReceived.some((d) => d.name === datasetName)) {
              datasetsReceived.push({
                name: datasetName,
                hasResults: false
              });
            }
          } else {
            console.warn("Invalid datasetName received in asynccancel:", datasetName);
          }

          updateUIAfterFetch($(this), datasets.length);
          updateViewAllButton($(this));
        })
        .on('typeahead:beforeclose', function (event, suggestions) {
          event.preventDefault()
        })
        .on('input', function () {
          datasetsReceived = [];
          updateViewAllButton($(this));
        });

        $this.on('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            handleManualSearch($this);
          }
        });

        injectSearchIcon($this);
    });

    function injectSearchIcon($element) {
      if (!$element.siblings('.input__icon--trailing').length) {
        var $icon = $('<i>', {
          class: 'material-icons input__icon input__icon--trailing',
          text: 'search',
          tabindex: 0,
          role: 'button',
          click: function () {
            handleManualSearch($element);
          }
        });

        $element.after($icon);
      }
    }

    function handleManualSearch($element) {
      const searchTerm = $element.val().trim();
      if (searchTerm) {
        const productByIdContainer = $element
          .siblings('.tt-menu')
          .find('.tt-dataset-productbyid');

        if (productByIdContainer.length && productByIdContainer.is(':visible')) {
          const suggestionLink = productByIdContainer
            .find('.tt-text-suggestion')
            .first();

          if (suggestionLink.length) {
            const suggestion = {
              ItemName: suggestionLink.text(),
              PageUrl: suggestionLink.attr('href'),
            };

            // redirect to the ProductByID page
            window.location.replace(suggestion.PageUrl);
            return;
          }
        }

        // fefault behavior: redirect to the search page
        const fullSearchUrl = constructFullSearchUrl($element, searchTerm);
        window.location.href = fullSearchUrl;
      }
    }

    function addRecentSearch(suggestion) {
      fetch('/api/user/add-recent-search', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          searchText: suggestion.ItemName,
          searchUrl: suggestion.PageUrl
        })
      })
      .catch(error => console.error("Error adding recent search:", error));
    }

    function updateUIAfterFetch($element, totalDatasets) {
      if (allDatasetsLoaded(datasetsReceived, totalDatasets)) {
        datasetsReceived = [];
      }
    }

    function allDatasetsLoaded(datasetsReceived, totalDatasets) {
      return datasetsReceived.length === totalDatasets;
    }

    function updateViewAllButton($element) {
      // remove existing button to avoid duplicates
      $('.tt-view-all-search-results').remove();

      let searchTerm = $element.val().trim();
      if (!searchTerm) {
        return;
      }

      const quotedTerm = truncateAndQuoteTerm(searchTerm);
      const fullSearchUrl = constructFullSearchUrl($element, searchTerm);
      const buttonText = constructButtonText($element, quotedTerm);

      appendViewAllButton($element, fullSearchUrl, buttonText);
      ensureMenuVisibility($element);
    }

    function truncateAndQuoteTerm(term) {
      const maxLength = 10;
      const truncatedTerm = term.length > maxLength ? term.substring(0, maxLength) + ".." : term;
      return `'${truncatedTerm}'`;
    }

    function constructFullSearchUrl($element, searchTerm) {
      const baseSearchUrl = $element.attr('data-autocomplete-view-all-results');
      return `${baseSearchUrl}?searchtext=${encodeURIComponent(searchTerm)}`;
    }

    function constructButtonText($element, quotedTerm) {
      const buttonTextTemplate = $element.data('site-search-flyout-autocomplete-button-text') || "Find {Term} in Advanced Search";
      return buttonTextTemplate.replace("{Term}", quotedTerm);
    }

    function appendViewAllButton($element, fullSearchUrl, buttonText) {
      $element.siblings('.tt-menu').append(
        `<div class="tt-view-all-search-results">
          <a href="${fullSearchUrl}" type="button" class="button button--long">${buttonText}</a>
        </div>`
      );
    }

    function ensureMenuVisibility($element) {
      const $menu = $element.siblings('.tt-menu');
      if ($menu.hasClass('tt-empty')) {
        $menu.css('display', 'block');
      }
    }
  }

  $(document).ready(function () {
    ns.initSiteSearchAutocomplete();
  });

})(jQuery, document, Crafted.Utilities);